export enum pageStatuses {
  INITIAL = 'INITIAL',
  LOADING = 'LOADING',
  RESULTS = 'RESULTS',
}

export enum outageStatuses {
  CLOSED = 'CLOSED',
  ACTIVE = 'ACTIVE',
  PLANNED = 'PLANNED',
}

export enum Modules {
  BREDBAAND = 'bredbaand',
  TELEFONI = 'telefoni',
  DEFAULT = '',
}
